import React from 'react';
import { Navbar, Container, Button, Image } from 'react-bootstrap';
import { loadStripe } from '@stripe/stripe-js';
import { useDispatch } from 'react-redux';
import { setValue } from '../store/paymentSlice';

// Initialize Stripe

const Header: React.FC = () => {
const key: string = process.env.REACT_APP_STRIPE_KEY as string

const useStripe = async () => {
    const stripe = await loadStripe(key); 
    
    if (!stripe) {
      console.error('Stripe failed to initialize.');
      return;
    }

    const { error } = await stripe.redirectToCheckout({
        lineItems: [
          {
            price: 'price_1RGXoBDFiwLqE43ZI8f3rzqO', // price_1RGXxEDFiwLqE43ZZkLaobGv
            quantity: 1,
          },
        ],
        mode: "payment",
        successUrl: `https://app.buildthatcv.com/success?session_id={CHECKOUT_SESSION_ID}`,
        cancelUrl: `https://app.buildthatcv.com/cancel`,
      });

      console.error(error.message);
    
      if (!error) {
        console.log('download everything')
      }
  };

  return (
    <Navbar bg="light" expand="lg">
      <Container fluid>
        <Navbar.Brand href="#">
          <Image
            src="/logo.png"
            alt="Logo"
            width="30"
            height="30"
            className="d-inline-block align-top me-2"
          />
          BuildThatCV
        </Navbar.Brand>
        <Button variant="primary" onClick={useStripe} className="ms-auto">
          Download (€1.50)
        </Button>
      </Container>
    </Navbar>
  );
};

export default Header;
